import {Button,Banner, Link} from "@shopify/polaris";
interface Props {
    title?: string | null | undefined;
    onDismiss: () => void;
    showAlert: boolean;
}
function CriticalError({showAlert,onDismiss, title}: Props) {

    const openSupport = () => {
        window.open('mailto:support@eastsideco.com', '_blank');
    };



    return (
        <>
            {showAlert &&
            <div className="mb-20">
                <Banner
                    title={title ? title : 'Error occurred during operation'}
                    action={{content: 'Contact support', onAction() {
                        openSupport()
                        }}}
                    onDismiss={onDismiss}
                    tone="critical"
                >
                    <p>
                        Sorry, there was an error while processing your request.
                        Pleas contact support to resolve the issue.
                    </p>
                 </Banner>
            </div>
            }
        </>

    );
}

export default CriticalError;
